import {
  GETALL_TIPOS_DOCUMENTOS,
  LOADING_GETALL_TIPOS_DOCUMENTOS,
  ACTIVO_TIPOS_DOCUMENTOS,
  SET_LOGOUT,
  CLEAR_ALL,
  PARAMS_TIPOS_DOCUMENTOS,
} from '../../../store/Types';

const initialState = {
  all: [],
  activo: null,
  loadingGetAll: false,
  params: {},
};

export const tiposDocumentosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_TIPOS_DOCUMENTOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case ACTIVO_TIPOS_DOCUMENTOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_TIPOS_DOCUMENTOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_TIPOS_DOCUMENTOS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
